import { useEffect, useState } from 'react';
import { RegulationsTable } from '@kw/quokka-ui';

import { fetchService } from '../../../../utils/fetchService';
import { useLocalStorage } from '../../../../utils/useLocalStorage';
import { getEvidencesCallbackWithToken, processRules, sortRegulation } from '../utils/dopplerUtil';

import { getReviewActionOptions } from '../utils/helper';

import { GuardianReviewModal } from '../GuardianReviewModal';

import { useFetchRuleSummaries } from '../utils/useFetchRuleSummaries';
import { verifyAuthPermission } from '../../../../auth/VerifyAuthPermission';
import { AuthPermissions } from '../../../../auth/AuthPermissions';

export const RegulationsTab = ({ analysisId, platform }: { analysisId: string; platform: string }) => {
  const [accessToken = ''] = useLocalStorage('accessToken', '');
  const [loading, setLoading] = useState(false);
  const [regulation, setRegulation] = useState({});
  const initialRegulationOption = 'masvs';

  const [selectedRule, setSelectedRule] = useState({});



  const [selectedRegulationControl, setSelectedRegulationControl] = useState({});

  const canReview = verifyAuthPermission(AuthPermissions.REVIEW_APPLICATION);

  const [isRuleReviewModalOpen, setIsRuleReviewModalOpen] = useState(false); 
  const ruleActionOptions = getReviewActionOptions(canReview, setIsRuleReviewModalOpen);
  
  const [isRegulationReviewModalOpen, setIsRegulationReviewModalOpen] = useState(false);
  const regulationControlActionOptions = getReviewActionOptions(canReview, setIsRegulationReviewModalOpen);

  const { reloadRuleSummariesData } = useFetchRuleSummaries(analysisId, {
    suspense: false,
    revalidateOnMount: false,
    revalidateOnFocus: false,
  });

  const fetchRegulations = async option => {
    setLoading(true);

    try {
      const data = await fetchService(`/eval/results/${analysisId}/regulations?type=${option || initialRegulationOption}`, accessToken);

      // process rules for each regulation
      for (const key of Object.keys(data.fail)) {
        data.fail[key] = processRules(data.fail[key]);
      }

      for (const key2 of Object.keys(data.review)) {
        data.review[key2] = processRules(data.review[key2]);
      }

      setRegulation({
        fail: sortRegulation(data.fail),
        review: sortRegulation(data.review),
        regulationMetadata: data.regulationMetadata,
      });
    } catch (err) {
      console.error(`Error loading rule summary data ${err}`);
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchRegulations(null);
  }, []);

  return (
    <>
      <GuardianReviewModal
        analysisId={analysisId}
        selectedItem={selectedRule}
        setLoading={setLoading}
        fetchData={reloadRuleSummariesData}
        reviewType="rule"
        afterSaveArgs={[]}
        isOpen={isRuleReviewModalOpen}
        setIsOpen={setIsRuleReviewModalOpen}
      />
      <GuardianReviewModal
        analysisId={analysisId}
        selectedItem={selectedRegulationControl}
        setLoading={setLoading}
        fetchData={fetchRegulations}
        reviewType="regulation"
        afterSaveArgs={[initialRegulationOption]}
        isOpen={isRegulationReviewModalOpen}
        setIsOpen={setIsRegulationReviewModalOpen}
      />
      <RegulationsTable
        initialRegulationOption={initialRegulationOption}
        regulation={regulation}
        uuid={analysisId}
        getEvidencesCallback={getEvidencesCallbackWithToken(accessToken)}
        platform={platform}
        loadRegulation={fetchRegulations}
        isLoading={loading}
        ruleActionOptions={ruleActionOptions}
        setSelectedRule={setSelectedRule}
        regulationControlActionOptions={regulationControlActionOptions}
        setSelectedRegulationControl={setSelectedRegulationControl}
      />
    </>
  );
};
